import { useState, useEffect } from 'react';
import InnerLayout from '../../Layout/InnerLayout';
import styles from './style/recommendCorse.module.scss';
import Button from '../../Utilities/Button';
import LoadingTable from '../../Utilities/LoadingTable';
import Alert from '../../Utilities/Alert';

import { BsFillPencilFill } from 'react-icons/bs';
import { MdOutlineDone, MdClose, MdOutlineKeyboardArrowLeft } from 'react-icons/md';

import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectLifeCycle, getPaeiRecommendCorse, putPaeiRecommendCorse, removeLoading } from '../../../store/slice/lifeCycle';

import { editModeHandler, editModeToggleHandler, selectLeftNavigate } from '../../../store/slice/navigate';
import { getListsLanguage, selectMultilingual } from '../../../store/slice/language/multilingual';
import Dropdown from '../../Utilities/DropdownDynamic';
import { VscGlobe } from 'react-icons/vsc';

const RecommendCorse = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, courseData, success } = useSelector(selectLifeCycle);
  const { lists } = useSelector(selectMultilingual);
  const { navigateToggle } = useSelector(selectLeftNavigate);
  const [courseList, setCourseList] = useState([]);
  const [isEditMode, setIsEditMode] = useState({ title: '', editMode: false });
  const [isSnackBarOpen, setIsSnackBarOpen] = useState(false);
  const [isMouseOver, setIsMouseOver] = useState({});

  const [code, setCode] = useState({
    text: '繁體中文',
    value: 1,
    code: 'zh-TW',
  });

  const [options, setOptions] = useState([]);
  const [choose, setChoose] = useState('繁體中文');

  useEffect(() => {
    dispatch(getListsLanguage());
  }, [dispatch]);

  useEffect(() => {
    const array = [];
    lists?.data?.forEach((item) => {
      array.push({ text: item.language, value: item.id, code: item.code });
    });
    setOptions(array);
  }, [lists]);

  useEffect(() => {
    dispatch(getPaeiRecommendCorse(code));
  }, [dispatch, code]);

  useEffect(() => {
    let newArr = [];
    if (courseData && code && courseData[code?.code]) {
      for (let key of Object.keys(courseData[code?.code])) {
        newArr.push({ title: key, recommend: courseData[key], multilingual: courseData[code?.code][key] });
      }
    }
    setCourseList(newArr);
  }, [loading, courseData, code]);

  const handleEditCorse = (title) => {
    dispatch(editModeHandler(true));
    setIsEditMode({ title: title, editMode: true });
  };

  const handleEditRecommend = (title, value, index) => {
    let newArr = structuredClone(courseList);
    let newObj = { ...newArr[index] };
    newObj.title = title;
    newObj.multilingual = value;
    newArr[index] = newObj;
    setCourseList(newArr);
  };

  const handlePostRecommend = (idx) => {
    const newArr = structuredClone(courseList);
    const newObj = { ...newArr[idx] };
    dispatch(
      putPaeiRecommendCorse({
        code: code?.value,
        in_case: newObj.title,
        course_description: newObj.recommend,
        multilingual: newObj.multilingual,
      })
    );
  };

  useEffect(() => {
    if (success) {
      dispatch(getPaeiRecommendCorse(code));
      setIsEditMode({ title: '', editMode: false });
      dispatch(editModeHandler(false));
      dispatch(removeLoading());
    }
  }, [dispatch, success, code]);

  const handleChangeLanguage = (value) => {
    setChoose(value?.text);
    setCode(value);
  };

  return (
    <InnerLayout>
      <div className={styles.PAEIcontainer}>
        <div className={styles.header}>
          <div className={styles.title}>課程建議</div>
          <div className={styles.scoreSetting}>
            <div className={styles.tick}></div>
            <div className={styles.scoreSettingBtn}>
              <div className={styles.btn}>
                <Button
                  title='返回PAEI'
                  type='tertiary'
                  disabled={isEditMode.editMode}
                  icon={<MdOutlineKeyboardArrowLeft />}
                  onClick={() => navigate('/dashboard/tdp/PAEI-setting/practical')}
                />
              </div>
            </div>
          </div>
        </div>
        <div className={styles.body}>
          <div className={styles.listTitle}>
            <div className={styles.left}>課程建議列表</div>
            <div className={styles.right}>
              <Dropdown
                icon={<VscGlobe className={styles.icon} />}
                color={'#5856d6'}
                background={'#DFDFF7'}
                value={choose}
                listItems={options}
                onChange={(e) => handleChangeLanguage(e)}
                caption={'text'}
              />
            </div>
          </div>
          <div className={styles.tableContainer}>
            <table width={'100%'}>
              {loading && <LoadingTable row={12} column={3} />}
              <thead>
                <tr>
                  <th width={'20%'}>PAEI風格</th>
                  <th width={'75%'}>人才雲系統建議課程</th>
                  <th width={'5%'}></th>
                </tr>
              </thead>
              {!loading && (
                <>
                  <tbody>
                    {courseList?.map((item, idx) => (
                      <tr key={item.title}>
                        <td
                          style={{
                            borderBottom: item.recommend && isEditMode.title !== item.title ? '1px solid #DDDDDD' : '0px',
                          }}
                        >
                          <div className={styles.tdTitle}>{item.title}</div>
                        </td>
                        {item.title === isEditMode.title && isEditMode.editMode === true ? (
                          <td>
                            <div className={styles.tdTitle}>
                              <textarea
                                placeholder='-'
                                value={item.multilingual ? item.multilingual : ''}
                                onChange={(e) => handleEditRecommend(item.title, e.target.value, idx)}
                              />
                            </div>
                            <div className={styles.iconFlex}>
                              <div
                                className={styles.iconBg}
                                onMouseOver={() =>
                                  setIsMouseOver({
                                    index: idx,
                                    closeBtn: true,
                                    saveBtn: false,
                                  })
                                }
                                onMouseLeave={() =>
                                  setIsMouseOver({
                                    index: idx,
                                    closeBtn: false,
                                    saveBtn: false,
                                  })
                                }
                              >
                                <Button icon={<MdClose />} type='quaternary' color='#999999' onClick={() => setIsSnackBarOpen(true)} />
                                {isMouseOver.index === idx && isMouseOver.closeBtn && <div className={styles.hoverStyle}>取消</div>}
                              </div>
                              <div
                                className={styles.iconBg}
                                onMouseOver={() =>
                                  setIsMouseOver({
                                    index: idx,
                                    closeBtn: false,
                                    saveBtn: true,
                                  })
                                }
                                onMouseLeave={() =>
                                  setIsMouseOver({
                                    index: idx,
                                    closeBtn: false,
                                    saveBtn: false,
                                  })
                                }
                              >
                                <Button
                                  icon={<MdOutlineDone />}
                                  type='quaternary'
                                  color='#34C759'
                                  onClick={() => handlePostRecommend(idx)}
                                  disabled={!item.multilingual}
                                />
                                {isMouseOver.index === idx && isMouseOver.saveBtn && <div className={styles.hoverStyle}>儲存</div>}
                              </div>
                            </div>
                          </td>
                        ) : (
                          <td
                            style={{
                              borderBottom: item.multilingual && isEditMode.title !== item.title ? '1px solid #DDDDDD' : '0px',
                            }}
                          >
                            <div className={styles.tdTitle}>{item.multilingual ? item.multilingual : '-'}</div>
                          </td>
                        )}
                        {item.title !== isEditMode.title && isEditMode.editMode === true && (
                          <td
                            style={{
                              borderBottom: item.multilingual && isEditMode.title !== item.title ? '1px solid #DDDDDD' : '0px',
                            }}
                          >
                            <div
                              className={styles.tdIcon}
                              onClick={() => {
                                if (!isEditMode.editMode) {
                                  handleEditCorse(item.title);
                                } else {
                                  setIsSnackBarOpen(true);
                                }
                              }}
                            >
                              <Button icon={<BsFillPencilFill />} type='pure' />
                              {!item.multilingual && <div className={styles.redDot}></div>}
                            </div>
                          </td>
                        )}
                        {item.title !== isEditMode.title && isEditMode.editMode === false && (
                          <td
                            style={{
                              borderBottom: item.multilingual && isEditMode.title !== item.title ? '1px solid #DDDDDD' : '0px',
                            }}
                          >
                            <div
                              className={styles.tdIcon}
                              onClick={() => {
                                if (!isEditMode.editMode) {
                                  handleEditCorse(item.title);
                                } else {
                                  setIsSnackBarOpen(true);
                                }
                              }}
                            >
                              <Button icon={<BsFillPencilFill />} type='pure' />
                              {!item.multilingual && <div className={styles.redDot}></div>}
                            </div>
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </>
              )}
            </table>
          </div>
        </div>
      </div>
      <Alert
        mainTitle='跳過目前正在編輯的項目嗎？'
        subTitle='系統可能不會儲存你所做的變更'
        leftButtonText='繼續編輯'
        rightButtonText='跳過'
        isOpen={isSnackBarOpen || (isEditMode.editMode && navigateToggle)}
        onClose={() => {
          setIsSnackBarOpen(false);
          dispatch(editModeToggleHandler(false));
        }}
        onConfirm={() => {
          setIsEditMode({ title: '', editMode: false });
          setIsSnackBarOpen(false);
          dispatch(editModeHandler(false));
          dispatch(editModeToggleHandler(false));
          dispatch(getPaeiRecommendCorse(code));
        }}
      />
    </InnerLayout>
  );
};

export default RecommendCorse;
